import './App.css';
import Navbar from './components/Navbar/Navbar';
import Intro from './components/Intro/Intro';
import Skills from './components/Skills/Skills';
import Works from './components/Works/Works';
import Contact from './components/Contact/Contact';
import Schedule from './components/Schedule/Schedule';
import Agenda from './components/Agenda/Agenda';
import Footer from './components/Footer/Footer';
import Moon from './components/Moon/Moon';

function App() {
  return (
   <div className='App'>
  <Navbar></Navbar>
<Intro></Intro>
<Agenda></Agenda>
<Skills></Skills>
<Schedule></Schedule>
<Works></Works>
<Contact></Contact>
<Footer></Footer>
<Moon></Moon>

   </div>
  
  );
}

export default App;
